import React from 'react';
import { Collapse } from 'antd';
import classNames from 'classnames';

import IconCustom from 'src/components/Icon/Custom';

import classes from './index.module.less';

const { Panel } = Collapse;

export type CollapsibleListProps = {
	panels: Array<{
		header: string;
		children: string;
		key: string;
	}>;
};

const CollapsibleList = ({ panels }: CollapsibleListProps) => {
	return (
		<div className={classNames(classes['collapsible-list'])}>
			<Collapse
				bordered={false}
				expandIcon={({ isActive }) => (
					<IconCustom iconName="plus-icon" rotate={isActive ? 135 : 0} />
				)}
				expandIconPosition="right"
			>
				{panels.map(({ children, header, key }, index) => (
					<Panel
						header={<div className={classes.header}>{header}</div>}
						key={key}
						style={{
							...(index === panels.length - 1
								? {
										border: 'none',
								  }
								: {
										borderBottom: '1px solid #000000',
								  }),
							padding: 0,
							backgroundColor: 'white',
						}}
					>
						<div
							dangerouslySetInnerHTML={{
								__html: children,
							}}
						/>
					</Panel>
				))}
			</Collapse>
		</div>
	);
};

export default CollapsibleList;
